export const START_NEW_APP_DEFAULT_MESSAGE = 'Start a new application';
export const CONTINUE_APP_DEFAULT_MESSAGE = 'Continue your application';
export const APP_SAVED_SUCCESSFULLY_DEFAULT_MESSAGE =
  'We’ve saved your application.';
export const FINISH_APP_LATER_DEFAULT_MESSAGE = 'Finish this application later';
export const UNAUTH_SIGN_IN_DEFAULT_MESSAGE =
  'Sign in to start your application';
export const APP_TYPE_DEFAULT = 'application';
export const APP_ACTION_DEFAULT = 'applying';
export const REVIEW_APP_DEFAULT_MESSAGE = 'Review application';
export const FILE_UPLOAD_NETWORK_ERROR_MESSAGE =
  'We couldn’t upload your file due to a connection problem. Try again in a few moments.';
export const FILE_UPLOAD_REFRESH_ERROR_MESSAGE =
  'We couldn’t upload your file due to a network error. Try again in a few moments.';
export const FILE_UPLOAD_FORBIDDEN_ERROR_MESSAGE =
  'You don’t have permission to upload this file. Try signing in again.';
export const FILE_UPLOAD_FORBIDDEN_UNAUTHENTICATED_ERROR_MESSAGE =
  'We couldn’t upload your file. Try again in a few moments.';

export const accountTitleLabels = {
  CHECKING: 'Checking Account',
  SAVINGS: 'Savings Account',
  NOBANK: 'No Bank Account',
};

export const REVIEW_AND_SUBMIT = 'Review and submit';
export const STATEMENT_OF_TRUTH_ID = 'statement-of-truth';
export const STATEMENT_OF_TRUTH_SCROLL = 'statementOfTruthScrollElement';
